<template>
    <section :style="{ backgroundColor: footerBgColor }" class="py-4 sm:py-8 lg:py-12">
      <div class="w-full px-4 mx-auto max-w-7xl">
        <div class="flex flex-col items-center justify-between sm:flex-row gap-y-3">
          <div>
            <nuxt-img
              class="md-max:w-32"
              sizes="xs:128px sm:128px md:128px lg:160px xl:204px 2xl:204px"
              preload
              fetchpriority="high"
              format="webp"
              :src="logoSrc"
              :alt="logoAlt"
              width="166"
              height="44"
            />
          </div>
          <div class="sm:text-base text-15 font-ww-light">
            <span>{{ new Date().getFullYear() }}</span> {{ copyrightText }}
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script setup>
  const props = defineProps({
    logoSrc: {
      type: String,
      default: "/assets/images/logo-lifeboost-black.png"
    },
    logoAlt: {
      type: String,
      default: "logo"
    },
    copyrightText: {
      type: String,
      default: "Copyright All Rights Reserved"
    },
    footerBgColor: {
      type: String,
      default: "#EEEEEE"
    }
  });
  
  defineBuilderComponent({
    friendlyName: "SimpleFooter",
    inputs: [
      {
        name: "logoSrc",
        type: "file",
        friendlyName: "Logo Image",
        allowedFileTypes: ["jpeg", "jpg", "png", "webp", "svg"],
        defaultValue: "/assets/images/logo-lifeboost-black.png"
      },
      {
        name: "logoAlt",
        type: "string",
        friendlyName: "Logo Alt Text",
        defaultValue: "logo"
      },
      {
        name: "copyrightText",
        type: "string",
        friendlyName: "Copyright Text",
        defaultValue: "Copyright All Rights Reserved"
      },
      {
        name: "footerBgColor",
        type: "color",
        friendlyName: "Footer Background Color",
        defaultValue: "#EEEEEE"
      }
    ]
  });
  </script>
  